  <!-- 发货人查询 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug ref="mytable" :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <view-addr :addrTableData="A_tableData" :addrTableHead="A_tableHead" />
      <paging ref="pags" :pageNum="DiaTbable.pageStart" :total="DiaTbable.pageCount" :size="DiaTbable.pageTotal" @handleSizeChange="DiahandleSizeChange" @handleCurrentChange="DiahandleCurrentChange" />
    </my-dialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" @changeCallback="rowCallback">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import myDialog from "@/components/Dialog.vue";
import ViewAddr from "@/pages/Customers/ConsigneeMOD/ViewAddr.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1,exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    myDialog,
    ViewAddr,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "发货人查询", //导出时默认文件名
        apiName: "/admin/v3/tms/customer/getPersonnelList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "查看地址",
          method: "viewAddr",
          permissVal: "admin:customer:getPersonnelAddrList",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "发货人名称",
          field: "name",
          placeholder: "请输入",
        },

        {
          type: "select",
          label: "所属网点",
          field: "deptId",
          placeholder: "请选择",
          setLabel: "departmentName",
          setValue: "deptId",
          selectOptions: [],
        },
        {
          type: "input",
          label: "发货单位",
          field: "companyName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "所属客户",
          field: "customerId",
          setLabel: "customerName",
          setValue: "customerId",
          placeholder: "请选择",
          selectOptions: [],
        },
      ],

      queryData: {
        companyName: null,
        customerId: null,
        deptId: null,
        name: null,
        endCreateTime: null,
        startCreateTime: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },

        {
          name: "所属客户",
          field: "customerName",
          sort: 5,
          isShow: true,
          isTotal: false,
        },
        {
          name: "发货人",
          field: "name",
          sort: 5,
          isShow: true,
          isTotal: false,
        },
        {
          name: "发货单位",
          field: "companyName",
          sort: 5,
          isShow: true,
          isTotal: false,
        },
        {
          name: "联系电话",
          field: "tel",
          sort: 6,
          isShow: true,
          isTotal: false,
        },
        {
          name: "手机号码",
          field: "phone",
          sort: 1,
          isTotal: false,
          isShow: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 1,
          isShow: true,
          isTotal: false,
        },
        {
          name: "新增人",
          field: "createUserName",
          sort: 19,
          isShow: true,
          isTotal: false,
        },

        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isTotal: false,
          isShow: true,
        },
      ],
      sortName: "发货人查询", //  排序名
      pageGroupName: "Consignor",
      //   查看地址弹窗
      diaWidth: "60%",
      dialogTitle: "地址列表",
      isShowDialog: false,
      A_tableData: [],
      A_tableHead: [
        {
          name: "发货人",
          field: "personnelName",
          width: "120",
        },
        {
          name: "发货单位",
          field: "deptName",
          width: "120",
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
        },
        {
          name: "手机号码",
          field: "phone",
          width: "120",
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
        },
        {
          name: "详细地址",
          field: "address",
          width: "120",
        },
        {
          name: "地址简称",
          field: "addressName",
          width: "120",
        },

        {
          name: "创建人",
          field: "createUserName",
          width: "120",
        },

        {
          name: "备注",
          field: "remarks",
          width: "120",
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "120",
        },
      ],
      DiaTbable: {
        pageStart: 1,
        pageCount: 0,
        pageTotal: 20,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    this.getDeptList();
    this.getCustomerList();
  },
  watch: {},
  methods: {
        // 获取客户列表
    getCustomerList(customerName) {
      this.$API
        .CustomerList({
          // customerName:this.queryData4.customerName,
          customerName: customerName || '',
          pageStart: 1,
          pageTotal: 500,
          approveStatus: 'tong_guo:approve_status',
        })
        .then((res) => {
          this.baseConfig[4].selectOptions = res.data.result.data || []
        })
    },
    // 获取发货人列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startCreateTime = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endCreateTime = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.queryData.personnelType = "fa_jian:personnel_type";
      this.$API.PersonnelList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---发货人列表`);
        }
      });
    },

    // 获取查询框网点字段
    getDeptList() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[2].selectOptions = res.data.result?.data || [];
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 获取查询框网点字段
    getDeptList() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[2].selectOptions = res.data.result?.data || [];
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 获取人员地址列表
    GetPersonnelAddrList(data) {
      this.DiaTbable.personnelId = data;
      this.$API.PersonnelAddrList(this.DiaTbable).then((res) => {
        if (res.data.status === "success") {
          this.A_tableData = res.data.result.data || [];
          this.DiaTbable.pageCount = res.data.result.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---人员地址列表`);
        }
      });
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 查看地址
    viewAddr(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.GetPersonnelAddrList(this.selectTableData[0].personnelId);
        this.isShowDialog = true;
      }
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    // 查看地址弹窗事件
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
    DiahandleSizeChange(val) {
      this.DiaTbable.pageTotal = val;
      this.GetPersonnelAddrList();
    },
    DiahandleCurrentChange(val) {
      this.DiaTbable.pageStart = val;
      this.GetPersonnelAddrList();
    },
  },
};
</script>
      <style scoped lang="less">
</style>
      